var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n  button {\n    margin-top: 12px;\n  }\n  .a-field {\n    @media (max-width: 768px) {\n      padding-left: 0px;\n      padding-right: 0px;\n    }\n  }\n"], ["\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n  button {\n    margin-top: 12px;\n  }\n  .a-field {\n    @media (max-width: 768px) {\n      padding-left: 0px;\n      padding-right: 0px;\n    }\n  }\n"]);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import InputText from "../InputText";
import Form from "../Form";
import Field from "../Form/Field";
import { Row, Col } from "react-flexa";
import Button from "../Button";
import { validateName, validatePhoneNumber, validateEmail, validateEmployees, validateGroupLeadForm } from './validation';
var Wrapper = styled.div(_templateObject);

var LeadformGroup = function LeadformGroup(props) {
  var endpoint = props.endpoint,
      track = props.track,
      _props$isEmailRequire = props.isEmailRequired,
      isEmailRequired = _props$isEmailRequire === undefined ? true : _props$isEmailRequire;

  var _useState = useState(false),
      isValid = _useState[0],
      setValid = _useState[1];

  var _useState2 = useState(),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  var _useState3 = useState(),
      lastName = _useState3[0],
      setLastName = _useState3[1];

  var _useState4 = useState(),
      phoneNumber = _useState4[0],
      setPhoneNumber = _useState4[1];

  var _useState5 = useState(),
      email = _useState5[0],
      setEmail = _useState5[1];

  var _useState6 = useState(),
      employees = _useState6[0],
      setEmployees = _useState6[1];

  var _useState7 = useState("Leave your details"),
      buttonText = _useState7[0],
      setButtonText = _useState7[1];

  useEffect(function () {
    var isValid = validateGroupLeadForm({
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber,
      employees: employees,
      email: email
    });
    setValid(isValid);
  });

  var submit = function submit() {
    var date = new Date().toJSON();
    var data = {
      senderReference: "Website-Callback",
      fromNumber: phoneNumber,
      emailAddress: email,
      campaign: "Microsite Leadform",
      replyTime: date,
      firstName: firstName,
      lastName: lastName,
      packageId: "sim-sme",
      numEmployees: employees
    };
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (track) {
          track();
        }

        setButtonText("Sent!");
      }
    };

    xhr.open("POST", endpoint);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(data));
  };

  return React.createElement(Wrapper, null, React.createElement(Form, {
    noValidate: !isValid
  }, React.createElement(Row, null, React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    minLength: "1",
    onChange: function onChange(e) {
      return setFirstName(e.target.value);
    },
    validates: validateName(firstName),
    label: "First name"
  }))), React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    minLength: "1",
    onChange: function onChange(e) {
      return setLastName(e.target.value);
    },
    validates: validateName(lastName),
    label: "Last name"
  })))), React.createElement(Row, null, React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    display: "block",
    width: "100%",
    type: "number",
    min: "1",
    max: "9999999999",
    onChange: function onChange(e) {
      return setPhoneNumber(e.target.value);
    },
    validates: validatePhoneNumber(phoneNumber),
    label: "Phone number"
  }))), React.createElement(Col, {
    xs: 6
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: true,
    display: "block",
    width: "100%",
    type: "number",
    min: "1",
    max: "9999999999",
    onChange: function onChange(e) {
      return setEmployees(e.target.value);
    },
    validates: validateEmployees(employees),
    label: "No. of employees"
  })))), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(Field, null, React.createElement(InputText, {
    required: isEmailRequired,
    type: "email",
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    },
    validates: email && validateEmail(email, isEmailRequired),
    label: "Email address"
  })))), React.createElement(Button, {
    disabled: !isValid,
    size: "medium",
    colour: "primary",
    onClick: function onClick() {
      return submit();
    }
  }, buttonText)));
};

export default LeadformGroup;